export const logos = {
  logos: {
    button: {
      add: 'ADD LOGO',
      configure: 'CONFIGURE',
      update: 'UPDATE',
    },
    configure: {
      title: '{{name}} Logo Settings',
    },
    deleteConfirmInline: 'Delete logo? This cannot be undone.',
    enums: {
      positioning: {
        0: 'Bottom Right',
        1: 'Top Right',
        2: 'Bottom Left',
        3: 'Top Left',
        4: 'Centered',
        5: 'Absolute',
        6: 'Relative',
      },
    },
    fileExplorer: {
      /* keep in sync with haiui/react/src/components/FileExplorer/FileExplorer-helpers.ts */
      ascendingText: 'Ascending',
      descendingText: 'Descending',
      sortOrderText: 'Sort Order',
      moveModalTitleText: 'Move Files',
      moveModalCurrentLocationText: 'Current Location:',
      moveModalNewLocationText: 'New Location:',
      moveModalCancelButtonText: 'Cancel',
      moveModalConfirmButtonText: 'Move',
      deleteFilesDialogCancelText: 'CANCEL',
      deleteFilesDialogConfirmText: 'DELETE',
      deleteFilesDialogHeadlineText: 'Delete Selected Items?',
      deleteFilesDialogBodyText: 'This cannot be undone.',
      deleteFileHeadlinePendingSingle: 'Deleting the selected item.',
      deleteFileBodyTextPending: 'This may take a few moments.',
      deleteFileHeadlineSuccess: 'Items Successfully Deleted.',
      deleteFileHeadlineFail: 'Unable to Delete One or More Items.',
      deleteFileHeadlinePendingMulti: 'Deleting [count] items.',
      deleteFoldersWithFilesDialogCancelText: 'Cancel',
      deleteFoldersWithFilesDialogConfirmText: 'Delete',
      deleteFoldersWithFilesDialogHeadlineText: 'Delete Selected Items?',
      deleteFoldersWithFilesDialogBodyText: 'Items in folders will also be deleted. This cannot be undone.',
      emptyStateHeadingText: 'No Files',
      emptySearchHeadingText: 'No Search Results',
      emptyStateSubHeadingText: '',
      bulkActionDeleteButtonText: 'DELETE',
      bulkActionMoveButtonText: 'MOVE',
    },
    deleteModal: {
      title: 'Delete {{count}} logo?',
      title_plural: 'Delete {{count}} logos?',
      titleInProgress: 'Deleting {{count}} logo',
      titleInProgress_plural: 'Deleting {{count}} logos',
    },
    settings: {
      positioning: 'Position',
      x: 'X',
      y: 'Y',
      opacity: 'Opacity',
      relative: 'Use relative scaling',
      relativeTooltip:
        "If enabled, keeps the logo's dimensions constant in relation to the display area regardless of the input resolution.",
      scaling: 'Scaling',
    },
    import: {
      title: 'Add Logo',
    },
    noLogo: 'No Logo',
    notifications: {
      changeErrorMsg: 'Logo settings for {{interface}} could not be updated',
      changeSuccessMsg: 'Logo settings for {{interface}} updated',
      deleteErrorMsg_plural: '{{count}} logos could not be deleted',
      deleteErrorMsg: '{{count}} logo could not be deleted',
      deleteSuccessMsg: '{{count}} logo deleted',
      deleteSuccessMsg_plural: '{{count}} logos deleted',
      deleteSuccessWithErrorsMsg: '{{count}} logo deleted while {{failures}} could not be deleted',
      deleteSuccessWithErrorsMsg_plural: '{{count}} logos deleted while {{failures}} could not be deleted',
      importErrorMsg: 'Failed uploading logo',
      importSuccessMsg: 'Success uploading logo',
      importSuccessMsg_plural: 'Success uploading {{count}} logos',
      importNetworkError: 'A network error occured. ',
    },
    sections: {
      title: 'Configuration',
      logos: 'Logos',
    },
    validations: {
      x_rel: '0 - 1920',
      y_rel: '0 - 1080',
      x_abs: '0 - 3839',
      y_abs: '0 - 2159',
      fx: {
        x_rel: '0 - 1920',
        y_rel: '0 - 1080',
        x_abs: '0 - 4095',
        y_abs: '0 - 2159',
      },
    },
  },
};
